export enum AudioSource {
  InputDevice = 'mic',

  /** The RTP connection. Usually nTouch, sometimes FreeSWITCH. */
  DirectLine = 'direct',

  /** The connection with the hearing person and other VIs. Usually Chime. */
  VoiceLine = 'chime',
}
